/* =========================================================
   HERMES Medias Térmicas v1 — warm editorial animations
   Combines: Aethera ribbon reveal · Innovation bullets ·
   Mindloop curves · NexaCore triptych · Yacht chapter labels ·
   Orbit float decorations · Lifestyle parallax soft
   ========================================================= */

(function () {
  /* ── Shared overlay activator (handles both spy + desktop-block modes) ── */
  function activateOverlay(mode) {
    const overlay = document.getElementById('hm-m1-caught');
    if (!overlay) return false;
    if (overlay.classList.contains('hm-m1-caught--active')) return false;
    overlay.classList.add('hm-m1-caught--active');
    overlay.classList.add(mode === 'desktop' ? 'hm-m1-caught--mode-desktop' : 'hm-m1-caught--mode-spy');
    try { console.clear(); } catch (_) {}
    try { window.history.replaceState({}, '', window.location.pathname); } catch (_) {}
    // Lock page scroll under the overlay
    try { document.documentElement.style.overflow = 'hidden'; document.body.style.overflow = 'hidden'; } catch (_) {}
    return true;
  }

  /* ── Desktop-only blocker: detect desktop on init & show friendly redirect ── */
  function initDesktopBlock(root) {
    if (!root.classList.contains('hm-m1--desktop-block')) return false;
    // Detection: any of (a) viewport >= 1024px, (b) hover: hover (mouse pointer present), (c) no touch
    const wideVP = window.matchMedia('(min-width: 1024px)').matches;
    const hasMouse = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const noTouch = !('ontouchstart' in window) && (navigator.maxTouchPoints || 0) === 0;
    const isDesktop = wideVP || (hasMouse && noTouch);
    if (isDesktop) {
      activateOverlay('desktop');
      return true;
    }
    return false;
  }

  function initAntiSpy(root) {
    if (!root.classList.contains('hm-m1--anti-spy')) return;

    function show() { activateOverlay('spy'); }

    document.addEventListener('contextmenu', (e) => { e.preventDefault(); show(); });
    document.addEventListener('dragstart', (e) => {
      const t = e.target;
      if (t && (t.tagName === 'IMG' || t.tagName === 'VIDEO' || t.tagName === 'PICTURE')) {
        e.preventDefault();
        show();
      }
    });
    document.addEventListener('keydown', (e) => {
      const cmb = e.ctrlKey || e.metaKey;
      const key = (e.key || '').toLowerCase();
      if (
        e.key === 'F12' ||
        (cmb && e.shiftKey && (key === 'i' || key === 'j' || key === 'c')) ||
        (cmb && (key === 'u' || key === 's' || key === 'p'))
      ) {
        e.preventDefault();
        show();
      }
    });
    function detectDevTools() {
      const threshold = 160;
      const widthGap = window.outerWidth - window.innerWidth;
      const heightGap = window.outerHeight - window.innerHeight;
      if (widthGap > threshold || heightGap > threshold) show();
    }
    setInterval(detectDevTools, 1500);
    window.addEventListener('resize', detectDevTools, { passive: true });
    setInterval(() => {
      const t0 = performance.now();
      try { debugger; } catch (_) {}
      const t1 = performance.now();
      if (t1 - t0 > 100) show();
    }, 4000);
  }

  /* ── Releasit COD integration ───────────────────── */
  function initReleasitIntegration(root) {
    const proxyCTAs = root.querySelectorAll('.hm-m1-hero__cta');

    function findRsiButton() {
      return document.querySelector('._rsi-buy-now-button:not([data-hmm1-handled])')
          || document.querySelector('#_rsi-buy-now-button-overwrite')
          || document.querySelector('[data-hmm1-main-cta]');
    }

    function tryClick(btn, attempt) {
      attempt = attempt || 0;
      const rsiBtn = findRsiButton();
      if (rsiBtn) {
        console.info('[HERMES medias-v1] Disparando Releasit modal via', rsiBtn.className || rsiBtn.id);
        rsiBtn.click();
        return true;
      }
      if (attempt < 10) {
        setTimeout(() => tryClick(btn, attempt + 1), 500);
      } else {
        console.warn('[HERMES medias-v1] Releasit no detectado — verifica config dashboard');
      }
      return false;
    }

    proxyCTAs.forEach(cta => {
      cta.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        tryClick(cta);
      });
    });

    if ('MutationObserver' in window) {
      const obs = new MutationObserver(() => {
        const rsiBtn = document.querySelector('._rsi-buy-now-button:not([data-hmm1-handled])');
        if (rsiBtn) {
          rsiBtn.setAttribute('data-hmm1-handled', '1');
          console.info('[HERMES medias-v1] Releasit button detectado:', rsiBtn.className);
          obs.disconnect();
        }
      });
      obs.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => obs.disconnect(), 15000);
    }
  }

  /* ── Variant selector (color swatches) ──────────── */
  function initVariantSelector(root) {
    const wrap = root.querySelector('[data-hmm1-variants]');
    if (!wrap) return;
    const jsonEl = wrap.querySelector('[data-hmm1-variants-json]');
    if (!jsonEl) return;

    let variants;
    try { variants = JSON.parse(jsonEl.textContent.trim()); } catch (e) { return; }
    if (!variants || !variants.length) return;

    const variantInput = root.querySelector('[data-hmm1-variant-input]');
    const heroPriceNow = root.querySelector('.hm-m1-hero__price-now');
    const heroPriceWas = root.querySelector('.hm-m1-hero__price-was s');
    const finalPriceNow = root.querySelector('.hm-m1-final__now');
    const finalPriceWas = root.querySelector('.hm-m1-final__was s');

    let selected = variants[0].options.slice();

    function formatPrice(cents) {
      const amount = Math.floor(cents / 100);
      return '$' + amount.toLocaleString('es-CO');
    }

    function findVariant() {
      return variants.find(v => v.options.every((opt, i) => opt === selected[i]));
    }

    function updateUI() {
      const v = findVariant();
      if (!v) return;
      if (variantInput) variantInput.value = v.id;
      if (heroPriceNow) heroPriceNow.textContent = formatPrice(v.price);
      if (finalPriceNow) finalPriceNow.textContent = formatPrice(v.price);
      if (v.compare_at_price) {
        if (heroPriceWas) heroPriceWas.textContent = formatPrice(v.compare_at_price);
        if (finalPriceWas) finalPriceWas.textContent = formatPrice(v.compare_at_price);
      }
      try {
        window._RSI_COD_FORM_OVERWRITE_ATC_ITEMS = [{ id: v.id, quantity: 1 }];
      } catch (_) {}
      wrap.querySelectorAll('.hm-m1-variant-opt').forEach(btn => {
        const oi = parseInt(btn.dataset.optionIndex, 10);
        const val = btn.dataset.optionValue;
        const testSelection = selected.slice();
        testSelection[oi] = val;
        const exists = variants.find(va => va.available && va.options.every((o, i) => o === testSelection[i]));
        btn.classList.toggle('hm-m1-variant-opt--unavailable', !exists);
      });
    }

    wrap.querySelectorAll('.hm-m1-variant-opt').forEach(btn => {
      btn.addEventListener('click', () => {
        const oi = parseInt(btn.dataset.optionIndex, 10);
        const val = btn.dataset.optionValue;
        btn.parentElement.querySelectorAll('.hm-m1-variant-opt--active, .hm-m1-swatch--active').forEach(b => {
          b.classList.remove('hm-m1-variant-opt--active');
          b.classList.remove('hm-m1-swatch--active');
        });
        btn.classList.add('hm-m1-variant-opt--active');
        btn.classList.add('hm-m1-swatch--active');
        selected[oi] = val;
        updateUI();
      });
    });

    updateUI();
  }

  function init() {
    const root = document.querySelector('.hm-m1');
    if (!root) return;

    // Desktop-block runs FIRST and short-circuits if it triggers (don't run other init in desktop-block mode)
    const desktopBlocked = initDesktopBlock(root);
    if (desktopBlocked) {
      console.info('[HERMES medias-v1] Desktop visitor blocked — showing mobile-redirect overlay');
      return; // skip variant selector, animations, etc — overlay is the entire UI
    }
    initAntiSpy(root);
    initVariantSelector(root);
    initReleasitIntegration(root);

    /* ───── 0) PRELOADER counter 000→100 + rotating words ───── */
    const preloader = root.querySelector('#hm-m1-preloader');
    const counter = root.querySelector('#hm-m1-counter');
    const bar = root.querySelector('#hm-m1-bar');
    const words = root.querySelectorAll('#hm-m1-words .hm-m1-pw');

    if (preloader && counter && bar) {
      let n = 0;
      let wordIdx = 0;
      const duration = 1800;
      const start = performance.now();
      function tick(now) {
        const elapsed = now - start;
        const progress = Math.min(elapsed / duration, 1);
        n = Math.floor(progress * 100);
        counter.textContent = String(n).padStart(3, '0');
        bar.style.width = (progress * 100) + '%';
        const wIdx = Math.min(Math.floor(progress * words.length), words.length - 1);
        if (wIdx !== wordIdx) {
          if (words[wordIdx]) words[wordIdx].classList.remove('active');
          if (words[wIdx]) words[wIdx].classList.add('active');
          wordIdx = wIdx;
        }
        if (progress < 1) {
          requestAnimationFrame(tick);
        } else {
          setTimeout(() => preloader.classList.add('hm-m1-done'), 300);
        }
      }
      requestAnimationFrame(tick);
    }

    /* ───── 1) Ribbon reveal hero headline (Aethera) ───── */
    root.querySelectorAll('.hm-m1-ribbon').forEach((el, blockIdx) => {
      const txt = el.dataset.text || el.textContent;
      el.innerHTML = '';
      const baseDelay = 2.2 + blockIdx * 0.35;
      txt.split(' ').forEach((word, i) => {
        const wrap = document.createElement('span');
        wrap.style.display = 'inline-block';
        wrap.style.overflow = 'hidden';
        wrap.style.verticalAlign = 'bottom';
        const span = document.createElement('span');
        span.className = 'hm-m1-ribbon__word';
        span.textContent = word + (i === txt.split(' ').length - 1 ? '' : ' ');
        span.style.animationDelay = (baseDelay + i * 0.08) + 's';
        wrap.appendChild(span);
        el.appendChild(wrap);
      });
    });

    /* ───── 2) Stat counter (count-up on viewport enter) ───── */
    const statNums = root.querySelectorAll('.hm-m1-stat__num');
    if ('IntersectionObserver' in window && statNums.length) {
      const statIO = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const el = entry.target;
            const target = parseInt(el.dataset.target || '0', 10);
            const suffix = el.dataset.suffix || '';
            const finalText = el.textContent.trim();
            const duration = 1400;
            const start = performance.now();
            function tick(now) {
              const p = Math.min((now - start) / duration, 1);
              const eased = 1 - Math.pow(1 - p, 3);
              const v = Math.floor(eased * target);
              el.textContent = (target >= 1000) ? v.toLocaleString('es-CO') : v + suffix;
              if (p < 1) requestAnimationFrame(tick);
              else el.textContent = finalText;
            }
            requestAnimationFrame(tick);
            obs.unobserve(el);
          }
        });
      }, { threshold: 0.4 });
      statNums.forEach(s => statIO.observe(s));
    }

    /* ───── 3) Letter-by-letter pull-quote reveal ───── */
    const pullquote = root.querySelector('[data-letter-reveal]');
    if (pullquote) {
      const src = pullquote.dataset.source;
      if (src && !pullquote.querySelector('span')) {
        const wrap = document.createElement('div');
        wrap.innerHTML = src;
        function letterize(node) {
          if (node.nodeType === 3) {
            const frag = document.createDocumentFragment();
            [...node.textContent].forEach(ch => {
              const s = document.createElement('span');
              s.innerHTML = ch === ' ' ? '&nbsp;' : ch;
              frag.appendChild(s);
            });
            node.parentNode.replaceChild(frag, node);
          } else if (node.nodeType === 1) {
            [...node.childNodes].forEach(letterize);
          }
        }
        [...wrap.childNodes].forEach(letterize);
        pullquote.innerHTML = wrap.innerHTML;
      }
      if ('IntersectionObserver' in window) {
        const lettersIO = new IntersectionObserver((entries, obs) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const spans = entry.target.querySelectorAll('span');
              spans.forEach((sp, i) => {
                sp.style.transitionDelay = (i * 0.025) + 's';
              });
              entry.target.classList.add('hm-m1-revealed');
              obs.unobserve(entry.target);
            }
          });
        }, { threshold: 0.3 });
        lettersIO.observe(pullquote);
      }
    }

    /* ───── 4) Lifestyle parallax soft ───── */
    const lifeBg = root.querySelector('#hm-m1-life-bg');
    const lifeSection = root.querySelector('#hm-m1-lifestyle');
    if (lifeBg && lifeSection && 'IntersectionObserver' in window) {
      let active = false;
      const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => { active = entry.isIntersecting; });
      }, { threshold: 0 });
      io.observe(lifeSection);
      function onScroll() {
        if (!active) return;
        const r = lifeSection.getBoundingClientRect();
        const vh = window.innerHeight;
        const progress = 1 - (r.top + r.height) / (vh + r.height);
        const ty = (progress - 0.5) * 80; // -40px to +40px
        lifeBg.style.transform = `translateY(${ty}px)`;
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* ───── 5) Bullet list stagger reveal on enter ───── */
    const bulletLists = root.querySelectorAll('.hm-m1-bullets');
    if ('IntersectionObserver' in window && bulletLists.length) {
      bulletLists.forEach(list => {
        const items = list.querySelectorAll('li');
        items.forEach((li, i) => {
          li.style.opacity = '0';
          li.style.transform = 'translateY(12px)';
          li.style.transition = `opacity 0.55s ${0.08 * i + 0.1}s var(--ease-warm, ease), transform 0.55s ${0.08 * i + 0.1}s var(--ease-warm, ease)`;
        });
      });
      const bIO = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('li').forEach(li => {
              li.style.opacity = '1';
              li.style.transform = 'translateY(0)';
            });
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3 });
      bulletLists.forEach(l => bIO.observe(l));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
